import resetForm from './resetForm';
import toggleModal from './toggleModal';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(toggleModal(false));
};
